import { ApiResult } from './PromiseResult';
import { AuthResult } from './AuthResult';
import {
  OtpData,
  PasswordInput,
  RecaptchaData,
  TabView_Data,
  Form_Data
} from './util.models';
import { CountrySelectedValue } from './doctorregistration';
import { SelectItem } from 'primeng/api/selectitem';
import { Payment_Data } from './basket';
import { InvoicePrint } from './transactions';
import { ProviderService } from '../constant/constant';
import { SrvRecord } from 'dns';
export class ProviderRegistrationApiData {
  provider: ProviderRegistration = new ProviderRegistration();
  create_api_result: ApiResult = new ApiResult(false);
  otp_data: OtpData = new OtpData(0);
  auth_result: AuthResult = new AuthResult();
}

export class ProviderRegistration {
  name: string = '';
  country_id: number = null;
  email: string = '';
  phone_number: string = '';
  recaptcha: string = '';
  password: string = '';
  identification_number: string = '';
  contact_name: string = '';
  shortName: string = '';
}

export class ProviderRegistrationData {
  other_data: ProviderRegistrationOtherData =
    new ProviderRegistrationOtherData();
  api_data: ProviderRegistrationApiData = new ProviderRegistrationApiData();
}


export class ProviderRegistrationOtherData {
  first_name: string = '';
  middle_name: string = '';
  last_name: string = '';
  selected_country: string = '';
  selected_country_acronym: string = '';
  primary_contact_no: string = '';
  selected_country_data: CountrySelectedValue = new CountrySelectedValue();
  recaptchaData: RecaptchaData = new RecaptchaData();
  countries: SelectItem[] = [];
  max_date: Date = new Date();
  tabViewData: TabView_Data = new TabView_Data(0, 1);
  password_input: PasswordInput = new PasswordInput();
}
export class ProviderMetadata {
  id: string;
  metadata: {
    images: {
      logo: {
        default: string;
      };
    };
  };
  provider: {
    name: string;
    is_primary_provider: boolean;
  };
}

export class FetchProviderMetadataResponse {
  fetchProviderMetadata: ProviderMetadata;
}


export class UpdateSupportMetadata {
  contact: {
    support: {
      phoneNumber: number;
      email: string;
      address: string;
    }
  }
}

export class SupportMetadata {
  create_api_result: ApiResult = new ApiResult(false);
  api_data: UpdateSupportMetadata = new UpdateSupportMetadata();
}

export class UpdateProviderMetadata {
  create_api_result: ApiResult = new ApiResult(false);
  api_data: UpdateLogo = new UpdateLogo();
  form_data: Form_Data = new Form_Data();
}

export class ApproveProvider {
  create_api_result: ApiResult = new ApiResult(false);
}

export class ProviderTransactions {
  create_api_result: ApiResult = new ApiResult(false);
}

export class ProviderCountries {
  create_api_result: ApiResult = new ApiResult(false);
}

export class UpdateLogo {
  file: File;
}

export interface FindProvider {
  findProvider: {
    id: string;
  };
}

export class ProviderLicencesData {
  api_data: ProviderLicensesApiData = new ProviderLicensesApiData();
  other_data: ProviderLicensesOtherData = new ProviderLicensesOtherData();
  create_api_result: ApiResult = new ApiResult(false);
}

export class ProviderLicensesApiData {
  licenses: ProviderLicenses[] = [];
  selected_license_id: string = "";
  api_result: ApiResult = new ApiResult(false);
  auth_result: AuthResult = new AuthResult();
}

export class ProviderLicensesOtherData {
  payment_data: Payment_Data = new Payment_Data();
  print_data: InvoicePrint = new InvoicePrint();
  tabview_Data: TabView_Data = new TabView_Data(0, 1);
}

export class ProviderLicenses {
  serial: number;
  id: string;
  name: string;
  expires_after: number;
  expiry_type: string;
  price: number;
  is_active: string;
  number_of_users: string | number;
  number_of_patients: string | number;
  renderedPrice: string;
}

export class CreateProviderKey {
  create_provider_key_api_data: CreateProviderKeyApiData =
    new CreateProviderKeyApiData();
  create_provider_key_other_data: CreateProviderKeyOtherData =
    new CreateProviderKeyOtherData();
}

export class CreateProviderKeyApiData {
  provider_service_token_type_id: number = 0;
  secret: string = '';
}
export class CreateProviderKeyOtherData {
  selected_token_type: string;
}
export interface ProviderOption {
  label: string;
  value: ProviderService;
}

export interface ProviderData {
  providerId: string;
  isPrimaryProvider: boolean;
  logoUrl: string;
  name: string;
  slug: string;
}

export class FetchProviderLicenses {
  id: string;
  expiry_date?: number;
  price_paid?: number;
  is_active?: boolean;
  number_of_users?: number;
  number_of_patients?: number;
  created_at?: string;
  updated_at?: string;
  license: {
    name: string;
  };
}


export class CreateLicenseBody {
  license_id: string;
  isTrial: boolean;
}

export class CreatePriority {
  specialty_id: number = 0;
  is_enabled: boolean = null;
  amount: number = 0;
  country_id: number = 0;
  consultation_type_id: number = 0;
  currency_country_id: number = 0;
  doctor_origin_country_ids: number[] = [];
}

export class CreatePriorityData {
  api_data: CreatePriorityApiData = new CreatePriorityApiData();
  other_data: CreatePriorityOtherData =
    new CreatePriorityOtherData();
  resetData() {
    this.api_data.priority = new CreatePriority();
    this.other_data.selected_consultation_type_data = new PrioritySelectedValue();
    this.other_data.selected_country_data = new CountrySelectedValue();
    this.other_data.selected_doctor_origin_data = [];
    this.other_data.selected_is_enabled_data = new PrioritySelectedValue();
    this.other_data.selected_specialty_data = new SpecilatySelectedValue();
  }

}

export class CreatePriorityApiData {
  priority: CreatePriority = new CreatePriority();
  create_api_result: ApiResult = new ApiResult(false);
  auth_result: AuthResult = new AuthResult();
}

export class SpecilatySelectedValue {
  id: number = 0;
  specialty_name: string = '';
}

export class PrioritySelectedValue {
  label: string;
  value: number | boolean;
}

export class CreatePriorityOtherData {
  consultations: SelectItem[] = [];
  countries: SelectItem[] = [];
  specialties: SelectItem[] = [];
  selected_country_data: CountrySelectedValue = new CountrySelectedValue();
  selected_doctor_origin_data: CountrySelectedValue[] = [];
  selected_specialty_data: SpecilatySelectedValue = new SpecilatySelectedValue();
  selected_consultation_type_data: PrioritySelectedValue = new PrioritySelectedValue();
  selected_is_enabled_data: PrioritySelectedValue = new PrioritySelectedValue();
}

export class PriorityList {
  id: number = 0
  transaction_type: string = "";
  consultation_name: string = "";
  priority_type: string = "";
  // specialty_id : number = 0;
  is_enabled: boolean = null;
  // amount: number = 0;
  renderedAmount: number = 0;
  // country_id: number = 0;
  number_of_consultations: number = 0;
}